var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "CHILE_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.1699 0.685547H0.380859V20.2625H10.1699V0.685547Z",
    fill: "#2530A9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.9438 10.4746H0.380859V20.2636H33.9438V10.4746Z",
    fill: "#C22623"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.27847 3.13184L4.52148 5.46083L5.68448 5.83884L5.27847 3.13184Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M5.27914 3.13184L6.03314 5.46083L4.86914 5.83884L5.27914 3.13184Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M7.60315 4.82227H5.16016V6.04727L7.60315 4.82227Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M7.60324 4.82227L5.62323 6.26227L4.90625 5.27026L7.60324 4.82227Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M2.94922 4.82227L4.93222 6.26227L5.64822 5.27026L2.94922 4.82227Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M2.94922 4.82227H5.39822V6.04727L2.94922 4.82227Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M6.71487 7.55846L5.96088 5.23145L4.79688 5.60945L6.71487 7.55846Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M6.71439 7.55882L4.7334 6.11981L5.45639 5.13281L6.71439 7.55882Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M3.83984 7.55882L5.81985 6.11981L5.09784 5.13281L3.83984 7.55882Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_86921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000010281331893844843750000012648683548643718570__13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M33.9438 0.685547H0.380859V20.2625H33.9438V0.685547Z",
    fill: "white"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_86921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M3.83984 7.55846L4.59384 5.23145L5.75784 5.60945L3.83984 7.55846Z",
    fill: "white"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChile);
export default __webpack_public_path__ + "static/media/CHILE.fa5745c73e01db26279442cab34fd222.svg";
export { ForwardRef as ReactComponent };